import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AdobeService } from 'src/app/services/adobe.service';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';

@Component({
	selector: 'app-welcome-authenticate',
	templateUrl: './welcome-authenticate.component.html',
	styleUrls: ['./welcome-authenticate.component.css']
})
export class WelcomeAuthenticateComponent implements OnInit {
	loading = true;

	step: number = 1;			// 1-3

	constructor(
		private fb: UntypedFormBuilder,
		private adobeService: AdobeService,
		private clientService: ClientService,
		private contextService: ContextService,
		private router: Router,
	) { }

	ngOnInit() {
		// Determine if the user has an adobe sign auth token.
		this.checkForAdobeSignUser();
		// If no, show the button

		// If yes, get the new token and then navigate to the form
	}

	checkForAdobeSignUser() {
		this.adobeService.getDoesUserExistWithSignatureCounts(this.contextService.procoreUserInfo.email, this.contextService.procoreContextObject.context.company_id)
			.subscribe((response) => {
				if (response.signatures) {
					this.contextService.signatureCount = response;
				}

				this.router.navigate(['/form']);
			}, (error) => {
				this.loading = false;
			});
	}

	authenenticateAdobeSign() {
		// if (!this.startedAuth && !this.startedDropboxSignAuth) {
		// this.startedDropboxSignAuth = true;

		let username = this.contextService.procoreUserInfo.email;
		let companyId = this.contextService.procoreContextObject.context.company_id;

		this.adobeService.getAuthUrl(username, companyId).subscribe((redirectUrl) => {
			if (redirectUrl) {
				if (this.contextService.procoreIsSandbox) {
					//window.open(redirectUrl + 'https://procore-dev.shakeit.ai', '_blank');
					window.open(redirectUrl + 'https://cool-cat-cd2045.netlify.app', '_blank');
				} else {
					//window.open(redirectUrl + 'https://procore.shakeit.ai', '_blank');
					window.open(redirectUrl + 'https://cool-cat-cd2045.netlify.app', '_blank');
				}
			}
		});
		// }
	}
}
